import { SpeakerPage } from './SpeakerPage';

export default(SpeakerPage);
